import { Link } from "react-router-dom";
import BaseCom from "../../../../components/BaseCom";
import Icon from "../../../../components/Icon";
import L from "../../../../components/Lang";
import AppActions from "../../../../components/Solusek/AppActions";
import DataView from "../../../../components/Solusek/DataView";
import { withParamsAndNavigate } from "../../../../components/WithParamsAndNavigate";
import { Pop } from "../../../../components/PopModal";

class UserManager extends BaseCom {

    remove = (item) => {
        Pop.showConfirm(<L>Delete User</L>, <><L>Are you sure you want to delete</L> <strong>{item.firstName}</strong> <strong>{item.lastName}</strong> <strong>{item.email}</strong>?</>, async () => {
            await this.postOrAlert('/api/admin/user/delete', item);
            this.success('Deleted.');
            this.rehash();
        });
    }

    edit = (item) => {
        this.props.navigate(String(item.id));
    }
    
    impersonate = (item) => {
        Pop.showConfirm(<L>Impersonate User</L>, <><L>Are you sure you want to impersonate</L> <strong>{item.firstName}</strong> <strong>{item.lastName}</strong> <strong>{item.email}</strong>?</>, async () => {
            let j = await this.postOrAlert('/api/admin/user/impersonate', item);
            if(j.errorCode === 0)
                window.location.assign('/');
        });
    }

    render() {
        return (
            <div className="container-fluid">
                <h1><L>Users</L></h1>
                <DataView api={'/api/admin/user/list'} hash={this.state.hash}
                    addons={[{
                        contentFunc: row => <div>
                            {row.isActive ? <span className="text-success"><Icon icon="faCircle" /></span>
                                : <span className="text-muted"><Icon icon="faCircle" /></span>}
                        </div>
                    }]}

                    actions={[
                        {
                        label: <Icon icon="faPencil" />,
                        onClick: this.edit
                    },
                    {
                        label: <Icon icon="faLock" />,
                        onClick: this.impersonate
                    },
                    {
                        label: <Icon icon="faTrash" />,
                        danger: true,
                        onClick: this.remove
                    }
                    ]}

                />
                <AppActions>
                    <Link to="new" className="btn btn-lg btn-primary">
                        <Icon icon="faPlus" /> <L>New User</L>
                    </Link>
                </AppActions>
            </div>
        );
    }
}

export default withParamsAndNavigate(UserManager);